<script setup>
import {computed, inject} from 'vue';
import {useDebug} from '../../../composables/useDebug';

const {log, error} = useDebug();
const $bus = inject('$bus');
import SearchInput from './SearchInput.vue';
import {useSearchStore} from '../store/useSearchStore';

const store = useSearchStore();

const props = defineProps({
    placeholder: {
        type: String,
        default: "",
    },
    value: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: null,
    },
    busy: Boolean,
});

const value = computed(() => props.value);
const searchQuery = computed(() => props.value);
const busy = computed(() => props.busy);
const searchType = computed(() => props.type);

const startSearch = () => {
    store.clickedOutside = false;
    if (busy.value) {
        return;
    }
    $bus.emit('startSearch', searchQuery.value);

};

const resetInput = () => {
    store.clickedOutside = false;
    if (busy.value) {
        return;
    }
    store.searchQuery = null;
    $bus.emit('restartSearch');
};
</script>

<template>
    <div class="search-form form" :class="{ 'is-loading': busy }">
        <div class="form-group">
            <SearchInput :busy="busy" :search-type="searchType"
                         :placeholder-value="props.placeholder"/>
        </div>
        <div class="icons">
            <div class="icon loupe" @click="startSearch">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.9183 16.3781L16.6594 16.6606L16.3768 16.9201C14.8282 18.3361 12.8164 19.1164 10.7115 19.1164C8.46652 19.1164 6.35649 18.2424 4.76931 16.6555C3.18472 15.0712 2.31241 12.9609 2.31241 10.7139C2.31241 8.46678 3.18472 6.35715 4.76931 4.77288C6.35649 3.18602 8.46652 2.31192 10.7115 2.31192C12.9558 2.31192 15.0664 3.18602 16.6536 4.77288C18.2409 6.35974 19.1151 8.46999 19.1151 10.7139C19.1151 12.8183 18.3347 14.8297 16.9183 16.3781ZM27.5346 25.2854L19.3303 17.0825C20.6894 15.2478 21.4273 13.0245 21.4273 10.7139C21.4273 7.85223 20.313 5.16141 18.289 3.13785C16.265 1.11429 13.5737 0 10.7115 0C7.84926 0 5.15793 1.11429 3.13397 3.13785C1.11251 5.15882 0 7.84964 0 10.7139C0 13.5787 1.11251 16.2695 3.13397 18.2899C5.15793 20.3135 7.84926 21.4283 10.7115 21.4283C13.0226 21.4283 15.2463 20.6898 17.0808 19.3316L25.2853 27.5343C25.5859 27.8343 25.9854 28 26.41 28C26.8346 28 27.234 27.8343 27.5346 27.5343C28.1551 26.914 28.1551 25.9051 27.5346 25.2854Z"/>
                </svg>
            </div>
            <div class="icon reset" @click="resetInput">
                <svg width="26" height="26" viewBox="0 0 26 26">
                    <path d="M1.75 24.25L24.25 1.75" stroke-width="2.25" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M1.75 1.75L24.25 24.25" stroke-width="2.25" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
                <div class="input-spinner"/>
            </div>
        </div>
    </div>
</template>
